





import { Component, Vue } from 'vue-property-decorator'
import PlayPane from '@/components/playPane.vue'

@Component
export default class Home extends Vue {
}
